/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Quick View functionality
function quickView(productHandle) {
  if (!productHandle) {
    return;
  }

  // Fetch product data using Shopify's Product API
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      // Create and show quick view modal
      const modalHtml = `
        <div class="quick-view-modal" id="quickViewModal-${product.id}">
          <div class="modal-content">
            <button class="close-modal" onclick="closeQuickView(${product.id})">&times;</button>
            <div class="modal-body">
              <div class="product-quick-view">
                <div class="quick-view-image">
                  <img src="${product.featured_image}" alt="${product.title}">
                </div>
                <div class="quick-view-details">
                  <h2>${product.title}</h2>
                  <div class="price">${formatMoney(product.price)}</div>
                  <div class="description">${product.description}</div>
                  <form action="/cart/add" method="post">
                    <select name="id" id="productSelect-${product.id}">
                      ${product.variants.map(variant => `
                        <option value="${variant.id}"${variant.available ? '' : ' disabled="disabled"'}>${variant.title} - ${formatMoney(variant.price)}</option>
                      `).join('')}
                    </select>
                    <button type="submit" class="add-to-cart-btn"${product.available ? '' : ' disabled'}>
                      ${product.available ? 'Add to Cart' : 'Sold Out'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;

      // Add modal to body if not exists
      if (!document.getElementById(`quickViewModal-${product.id}`)) {
        document.body.insertAdjacentHTML('beforeend', modalHtml);
      }

      // Show modal
      const modal = document.getElementById(`quickViewModal-${product.id}`);
      modal.style.display = 'flex';
    })
    .catch(error => console.error('Error loading quick view:', error));
}

// Close quick view modal
function closeQuickView(productId) {
  const modal = document.getElementById(`quickViewModal-${productId}`);
  if (modal) {
    modal.style.display = 'none';
  }
}

// Format money helper function
function formatMoney(cents) {
  const currencySymbol = window.theme?.moneyFormat || '${{amount}}';
  return currencySymbol.replace('{{amount}}', (cents / 100).toFixed(2));
}